function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useNavigationListItem } from "@sprout/list-navigation";
import { Draggable } from "react-beautiful-dnd";
import Post from "@sprout/client-components/dist/Post";
const PostWithDnDAndListNavigation = (props)=>{
    const { post , index , postProps , isDragDisabled  } = props;
    const { id  } = post;
    const stringId = String(id);
    const { navProps , helpers  } = useNavigationListItem(stringId, useMemo(()=>({
            index,
            object: post
        }), [
        index,
        post
    ]));
    return /*#__PURE__*/ _jsx(Draggable, {
        isDragDisabled: isDragDisabled,
        draggableId: stringId,
        index: index,
        children: (dragProvided, dragSnapshot)=>{
            return /*#__PURE__*/ _jsx(Post, _objectSpread({
                post: post,
                dragProvided: dragProvided,
                isDragging: dragSnapshot.isDragging,
                navigationItemHelpers: helpers
            }, postProps, navProps));
        }
    });
};
export default PostWithDnDAndListNavigation;
